import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FloorService } from "src/app/app/building/floor/floor.service";
import { CompanyService } from "../company.service";
import { Floor } from "src/app/app/building/floor/floor.model";
import { ModalController, NavController } from "@ionic/angular";
import { Location } from "@angular/common";
import { HeaderModel } from "src/app/_component/header/header.model";
import { ThisPlatform } from "src/app/_services/platform.service";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { SelectDropdownComponent } from "src/app/app/_component/select-dropdown/select-dropdown.component";
import { globalHelper } from "src/app/_helpers/global";
import { BuildingService } from "src/app/app/building/building.service";

@Component({
  selector: "app-add-company-floor",
  templateUrl: "./add-company-floor.page.html",
  styleUrls: [
    "./add-company-floor.page.scss",
    "./../../../_styles/ion-grid-box.scss",
  ],
})
export class AddCompanyFloorPage implements OnInit {
  constructor(
    public buildingService: BuildingService,
    public companyServ: CompanyService,
    public floorServ: FloorService,
    public p: ThisPlatform,
    private modalController: ModalController,
    private el: ElementRef
  ) {}

  @ViewChild("floorDropdown") dropdown: SelectDropdownComponent;

  companyId: number;
  floors: number[];

  headerInit: HeaderModel = {
    title: "COMPANY_FLOOR.ASSIGN_FLOOR",
    backDefaultHref: "/app/company",
  };

  validationError: boolean = false;

  form: FormGroup;

  ngOnInit() {
    this.companyServ.companyFloors = null;
    this.buildingService.loadBuildings();
    this.initForm();
  }

  initForm() {
    this.form = new FormGroup({
      building: new FormControl(""),
      floors: new FormControl("", {
        updateOn: "blur",
        validators: [Validators.required],
      }),
    });
  }

  onChangeBuilding(event) {
    this.dropdown.writeValue(null);
    if (event) {
      this.floorServ.getFloors(event.id).subscribe((floors: Floor[]) => {
        this.companyServ.companyFloors = floors;
      });
    }
  }

  Save() {
    if (!this.form.valid) {
      this.validationError = true;
      globalHelper.scrollToFirstInvalidControl(this.el);
      return;
    }

    let floors = [];

    this.form.value.floors.forEach((floor) => floors.push(floor.id));

    this.companyServ
      .addCompanyFloors(this.companyId, floors)
      .subscribe((res) => {
        this.close();
      });
  }

  close() {
    this.modalController.dismiss();
  }
  onSelectTouched(formControlName: string): void {
    this.form.get(formControlName).markAsTouched();
  }
}
